/* eslint-disable react-hooks/exhaustive-deps */
import {
  Badge,
  CircularProgress,
  Drawer,
  Grid,
  IconButton,
  Paper,
  withStyles,
} from "@material-ui/core";
import React, {
  useState,
  useEffect,
  Fragment,
  useRef,
  useCallback,
} from "react";
import { useLocation } from "react-router-dom";
import useWebSocket, { ReadyState } from "react-use-websocket";
import config from "../../utils/config";
import CloseOutlined from "@material-ui/icons/CloseOutlined";
import styles from "./styles.module.css";
import classNames from "classnames";
import uuid from "react-uuid";
import { useDispatch, useSelector } from "react-redux";
import { selectCompany } from "../../reducers/companySlice";
import { getUserById, selectUser } from "../../reducers/userSlice";
import { getOrdersByIdCompany, updateStatus } from "../../reducers/orderSlice";
import _orderBy from "lodash/orderBy";
import moment from "moment";
import {
  loadingOff,
  loadingOn,
  selectLoadingUI,
  selectSubsidiary,
} from "../../reducers/uiSlice";
import orderConstants from "../../constants/order.constants";
import { Notification as ReactNotification } from "../notification";
import { useSnackbar } from "notistack";
import { SelectReason } from "./selectRejectComponent";
import { TabNotification } from "./tabnotification";

import { Helmet } from "react-helmet";
import PDFOrder from "../../components/orders/pdf.component";
import shippingConstants from "../../constants/shipping.constants";
import paymentConstants from "../../constants/payments.constants";
import FileSaver from "file-saver";
import RefundModal from "./refundModal";
import lumaUtils from "@lumarketo/luma-utils";
import subsidiariesFunctions from "../../utils/subsidiaries";
import { selectSubsidiaries } from "../../reducers/subsidiarySlice";
import { useQueryClient } from "@tanstack/react-query";
import { NotificationIcon } from "../../assets/icons/svgIcons";

const noImage =
  "https://luma-photos.s3.amazonaws.com/photos/Webp.net-resizeimage.png";

export const WebSocketDemo = () => {
  //Public API that will echo messages sent to it back to the client
  const [messageHistory, setMessageHistory] = useState([]);
  const didUnmount = useRef(false);
  const queryClient = useQueryClient();
  const wakeLockRef = useRef(null);
  const pingIntervalRef = useRef(null);
  const visibilityChangeRef = useRef(null);
  const isPageVisibleRef = useRef(true);
  const audioRetryCountRef = useRef(0);
  const maxAudioRetries = 3;
  const [isPageVisible, setIsPageVisible] = useState(!document.hidden);
  const heartbeatAnimationRef = useRef(null);
  const keepAliveIntervalRef = useRef(null);
  const documentFocusRef = useRef(null);
  const windowFocusRef = useRef(null);
  const lastActivityRef = useRef(Date.now());

  const company = useSelector(selectCompany);
  const user = useSelector(selectUser);
  const location = useLocation();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const subsidiaryId = useSelector(selectSubsidiary);
  const subsidiaries = useSelector(selectSubsidiaries);
  const subsidiary = useSelector(selectSubsidiary);

  const filteredSubsidiaries =
    subsidiariesFunctions.gettingFilteredSubsidiariesByUserAccess(
      user,
      subsidiaries,
      subsidiary
    );
  const isSubsidiaryAutomaticAceptanceActive =
    subsidiariesFunctions.checkSubsidiaryAutomaticAcceptanceStatus(
      filteredSubsidiaries
    );

  const areSubsidiaryWithinWorkingHours =
    subsidiariesFunctions.checkIfSubsidiaryIsInWorkingHours();
  const checkCompanyAutomaticAcceptanceStatus = company?.UseAutoOrderAcceptance;

  // Enviar el companyId al conectarse para que el backend guarde la conexión
  // asociada a la empresa y solo la despierte cuando llega un pedido de esa
  // empresa (filtro opt-in en sendMessage). Cuando la empresa carga, la URL
  // cambia y react-use-websocket reconecta ya con el companyId.
  const wsUrl = company?._id
    ? `${config.websocketUrl}?companyId=${encodeURIComponent(company._id)}`
    : config.websocketUrl;

  const { lastMessage, readyState, sendMessage } = useWebSocket(
    wsUrl,
    {
      shouldReconnect: (closeEvent) => {
        /*
            useWebSocket will handle unmounting for you, but this is an example of a 
            case in which you would not want it to automatically reconnect
          */
        return didUnmount.current === false;
      },
      reconnectAttempts: 10,
      reconnectInterval: 3000,
      onOpen: () => {
        console.log("WebSocket connection opened");
        // El ping inicial se enviará automáticamente cuando la pestaña esté visible
        // y se establezca el intervalo de ping
      },
      onClose: (event) => {
        console.log("WebSocket connection closed", event);
      },
      onError: (error) => {
        console.error("WebSocket error:", error);
      },
    }
  );
  const [loading, setLoading] = useState(true);
  const [processLoading, setProcessLoading] = useState(false);
  const [newOrderId, setNewOrderId] = useState("");
  const [open, setOpen] = useState(false);
  const [showRedMessage, setShowRedMessage] = useState(false);

  // Función para obtener y mantener Wake Lock
  const requestWakeLock = async () => {
    try {
      if ("wakeLock" in navigator && navigator.wakeLock) {
        wakeLockRef.current = await navigator.wakeLock.request("screen");
        console.log("Wake Lock activado para evitar suspensión de la pestaña");

        // Manejar cuando el Wake Lock se libera (ej: cuando el usuario cambia de pestaña)
        wakeLockRef.current.addEventListener("release", () => {
          console.log("Wake Lock liberado");
        });
      }
    } catch (err) {
      // Wake Lock puede fallar si no está disponible o fue rechazado
      console.warn("No se pudo activar Wake Lock:", err);
    }
  };

  // Función para liberar Wake Lock
  const releaseWakeLock = async () => {
    if (wakeLockRef.current) {
      try {
        await wakeLockRef.current.release();
        wakeLockRef.current = null;
        console.log("Wake Lock liberado manualmente");
      } catch (err) {
        console.warn("Error al liberar Wake Lock:", err);
      }
    }
  };

  // Estrategia 1: Heartbeat con RequestAnimationFrame (mantiene la pestaña activa)
  const startHeartbeatAnimation = useCallback(() => {
    if (heartbeatAnimationRef.current) {
      cancelAnimationFrame(heartbeatAnimationRef.current);
    }

    const heartbeat = () => {
      // Actualizar timestamp de última actividad (esto mantiene el thread activo)
      lastActivityRef.current = Date.now();

      // Si el WebSocket está abierto y la pestaña está visible, puede enviar un keep-alive
      if (
        readyState === ReadyState.OPEN &&
        isPageVisible &&
        areSubsidiaryWithinWorkingHours
      ) {
        // El ping se maneja por interval, pero esto mantiene el ciclo activo
        // Podemos usar esto para detectar si el navegador está throttling
      }

      heartbeatAnimationRef.current = requestAnimationFrame(heartbeat);
    };

    heartbeatAnimationRef.current = requestAnimationFrame(heartbeat);
  }, [readyState, isPageVisible, areSubsidiaryWithinWorkingHours]);

  // Estrategia 2: Keep-alive adicional con actividad periódica mínima
  const startKeepAliveActivity = useCallback(() => {
    if (keepAliveIntervalRef.current) {
      clearInterval(keepAliveIntervalRef.current);
    }

    // Cada 10 segundos, hacer una actividad mínima que mantenga la pestaña activa
    keepAliveIntervalRef.current = setInterval(() => {
      if (isPageVisible && !document.hidden) {
        // Actualizar timestamp de última actividad (mantiene el thread activo)
        // Esta actividad mínima ayuda a prevenir que el navegador suspenda la pestaña
        lastActivityRef.current = Date.now();
      }
    }, 10000); // Cada 10 segundos
  }, [isPageVisible]);

  // Estrategia 3: Detectar focus/blur del documento y ventana
  const setupFocusListeners = useCallback(() => {
    const handleFocus = () => {
      console.log("Ventana/Documento obtuvo foco");
      lastActivityRef.current = Date.now();

      // Re-solicitar Wake Lock si se perdió
      if (!document.hidden && !wakeLockRef.current) {
        requestWakeLock();
      }

      // Reanudar heartbeat si estaba pausado
      if (readyState === ReadyState.OPEN) {
        startHeartbeatAnimation();
      }
    };

    const handleBlur = () => {
      console.log("Ventana/Documento perdió foco");
      // No cancelar completamente, pero reducir actividad
    };

    documentFocusRef.current = handleFocus;
    windowFocusRef.current = handleFocus;

    document.addEventListener("focus", handleFocus);
    document.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);

    return () => {
      if (documentFocusRef.current) {
        document.removeEventListener("focus", documentFocusRef.current);
        document.removeEventListener("blur", handleBlur);
      }
      if (windowFocusRef.current) {
        window.removeEventListener("focus", windowFocusRef.current);
        window.removeEventListener("blur", handleBlur);
      }
    };
  }, [readyState, startHeartbeatAnimation]);

  // Nota: El audio ya está manejado por playAudioWithRetry cuando hay notificaciones
  // No necesitamos una estrategia adicional de audio silencioso ya que el audio
  // de notificaciones ya mantiene cierta actividad cuando está en loop

  // Estrategia 5: Detectar throttling del navegador y reaccionar
  const detectThrottling = useCallback(() => {
    const checkInterval = 5000; // Verificar cada 5 segundos
    let lastCheck = Date.now();

    const checkThrottling = () => {
      const now = Date.now();
      const timePassed = now - lastCheck;
      const expectedTime = checkInterval;

      // Si el tiempo real es significativamente mayor al esperado, puede haber throttling
      if (timePassed > expectedTime * 1.5) {
        console.warn("Posible throttling detectado:", {
          esperado: expectedTime,
          real: timePassed,
          diferencia: timePassed - expectedTime,
        });

        // Intentar reactivar
        if (readyState === ReadyState.OPEN && isPageVisible) {
          sendMessage(
            JSON.stringify({
              action: "ping",
              reason: "throttling_recovery",
            })
          );
        }
      }

      lastCheck = now;
    };

    return setInterval(checkThrottling, checkInterval);
  }, [readyState, isPageVisible, sendMessage]);

  // Función mejorada para reproducir audio con reintentos
  const playAudioWithRetry = useCallback(
    (retryCount = 0) => {
      const audio = document?.getElementById("audio");
      if (!audio) {
        console.warn("Elemento de audio no encontrado");
        return;
      }

      try {
        audio.muted = false;
        audio.loop = company?.InfinityOrderAlert || false;

        const playPromise = audio.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log("Audio reproducido correctamente");
              audioRetryCountRef.current = 0;
            })
            .catch((error) => {
              console.warn(
                `Error al reproducir audio (intento ${retryCount + 1}):`,
                error
              );

              // Reintentar solo si no excede el máximo de intentos
              if (retryCount < maxAudioRetries) {
                setTimeout(() => {
                  playAudioWithRetry(retryCount + 1);
                }, 500 * (retryCount + 1)); // Backoff exponencial
              } else {
                console.error(
                  "No se pudo reproducir el audio después de varios intentos"
                );
                audioRetryCountRef.current = 0;
              }
            });
        }
      } catch (error) {
        console.error("Error al intentar reproducir audio:", error);
      }
    },
    [company?.InfinityOrderAlert]
  );

  const throttlingDetectorRef = useRef(null);

  useEffect(() => {
    return () => {
      didUnmount.current = true;
      releaseWakeLock();
      if (pingIntervalRef.current) {
        clearInterval(pingIntervalRef.current);
      }
      if (keepAliveIntervalRef.current) {
        clearInterval(keepAliveIntervalRef.current);
      }
      if (throttlingDetectorRef.current) {
        clearInterval(throttlingDetectorRef.current);
      }
      if (heartbeatAnimationRef.current) {
        cancelAnimationFrame(heartbeatAnimationRef.current);
      }
      if (visibilityChangeRef.current) {
        document.removeEventListener(
          "visibilitychange",
          visibilityChangeRef.current
        );
      }
      if (documentFocusRef.current) {
        document.removeEventListener("focus", documentFocusRef.current);
        document.removeEventListener("blur", () => { });
      }
      if (windowFocusRef.current) {
        window.removeEventListener("focus", windowFocusRef.current);
        window.removeEventListener("blur", () => { });
      }
    };
  }, []);

  // Manejo de Page Visibility API
  useEffect(() => {
    const handleVisibilityChange = () => {
      const isVisible = !document.hidden;
      isPageVisibleRef.current = isVisible;
      setIsPageVisible(isVisible);

      console.log(`Pestaña ${isVisible ? "visible" : "oculta"}`);

      if (isVisible) {
        // Cuando la pestaña se vuelve visible, solicitar Wake Lock
        requestWakeLock();

        // Enviar ping inmediato si el WebSocket está abierto
        if (readyState === ReadyState.OPEN && areSubsidiaryWithinWorkingHours) {
          sendMessage(
            JSON.stringify({
              action: "ping",
            })
          );
        }

        // Intentar reproducir audio si hay pedidos pendientes y estaba silenciado
        if (company?.InfinityOrderAlert && messageHistory?.length > 0) {
          const audio = document?.getElementById("audio");
          if (audio && audio.muted) {
            playAudioWithRetry();
          }
        }
      } else {
        // Cuando la pestaña se oculta, liberar Wake Lock (opcional)
        // Comentado para mantener el Wake Lock incluso en segundo plano
        // releaseWakeLock();
      }
    };

    visibilityChangeRef.current = handleVisibilityChange;
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Solicitar Wake Lock inicial si la pestaña está visible
    if (!document.hidden) {
      requestWakeLock();
    }

    return () => {
      if (visibilityChangeRef.current) {
        document.removeEventListener(
          "visibilitychange",
          visibilityChangeRef.current
        );
      }
      releaseWakeLock();
    };
  }, [
    readyState,
    sendMessage,
    areSubsidiaryWithinWorkingHours,
    company,
    messageHistory,
    playAudioWithRetry,
  ]);

  // Activar estrategias adicionales cuando la pestaña está visible y WebSocket está abierto
  useEffect(() => {
    if (isPageVisible && readyState === ReadyState.OPEN) {
      // Iniciar heartbeat con RequestAnimationFrame
      startHeartbeatAnimation();

      // Iniciar keep-alive activity
      startKeepAliveActivity();

      // Configurar listeners de focus/blur
      const cleanup = setupFocusListeners();

      // Iniciar detección de throttling
      throttlingDetectorRef.current = detectThrottling();

      return () => {
        if (heartbeatAnimationRef.current) {
          cancelAnimationFrame(heartbeatAnimationRef.current);
        }
        if (keepAliveIntervalRef.current) {
          clearInterval(keepAliveIntervalRef.current);
        }
        if (throttlingDetectorRef.current) {
          clearInterval(throttlingDetectorRef.current);
        }
        if (cleanup && typeof cleanup === "function") {
          cleanup();
        }
      };
    } else {
      // Limpiar cuando la pestaña está oculta o WebSocket cerrado
      if (heartbeatAnimationRef.current) {
        cancelAnimationFrame(heartbeatAnimationRef.current);
      }
      if (keepAliveIntervalRef.current) {
        clearInterval(keepAliveIntervalRef.current);
      }
      if (throttlingDetectorRef.current) {
        clearInterval(throttlingDetectorRef.current);
      }
    }
  }, [
    isPageVisible,
    readyState,
    startHeartbeatAnimation,
    startKeepAliveActivity,
    setupFocusListeners,
    detectThrottling,
  ]);

  // Mejorado: Ping más frecuente cuando la pestaña está visible
  useEffect(() => {
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
    }

    if (readyState === ReadyState.OPEN) {
      // Ping más frecuente (30 segundos) cuando está activa, menos frecuente (60 segundos) cuando está oculta
      const pingInterval = !isPageVisible ? 30000 : 60000;

      pingIntervalRef.current = setInterval(() => {
        if (areSubsidiaryWithinWorkingHours) {
          sendMessage(
            JSON.stringify({
              action: "ping",
            })
          );
          console.log("Ping enviado al WebSocket");
        }
      }, pingInterval);
    }

    return () => {
      if (pingIntervalRef.current) {
        clearInterval(pingIntervalRef.current);
        pingIntervalRef.current = null;
      }
    };
  }, [readyState, sendMessage, areSubsidiaryWithinWorkingHours, isPageVisible]);

  useEffect(() => {
    if (!("Notification" in window)) {
    } else {
      Notification.requestPermission();
    }
  }, []);

  useEffect(() => {
    if (lastMessage !== null) {
      const parsed = JSON.parse(lastMessage.data);
      if (parsed.order && parsed.order._id !== newOrderId) {
        setNewOrderId(parsed.order._id);
        if (
          parsed.order.idCompany === company._id &&
          (parsed.order.subsidiaryId === subsidiaryId || subsidiaryId === "all")
        ) {
          const found = messageHistory.find(
            (item) => item._id === parsed.order._id
          );
          if (!found) {
            const isNewPendingOrder = parsed.order.status === "picker-pending";
            if (!isNewPendingOrder) return; //TODO: Aplicar lógica para el modal, por ahora se ignora

            // Mostrar notificación del navegador
            if (Notification.permission === "granted") {
              try {
                new Notification(
                  `Nuevo pedido nro ${parsed.order.companyOrderNumber}`,
                  {
                    body: `Tiene un nuevo pedido, monto total ${parsed.order.total}`,
                    icon: "https://luma-photos.s3.amazonaws.com/content/nubefood.jpeg",
                    requireInteraction: true, // Mantiene la notificación visible hasta que el usuario la cierre
                  }
                );
              } catch (error) {
                console.warn("Error al mostrar notificación:", error);
              }
            }

            // Reproducir audio con reintentos
            playAudioWithRetry();

            setOpen(true);
            setLoading(false);
            setMessageHistory((prev) => prev.concat([{ ...parsed.order }]));
          }
        }
      }
    }
  }, [lastMessage, location.pathname, messageHistory]);

  useEffect(() => {
    if (company && company.InfinityOrderAlert) {
      const audio = document?.getElementById("audio");
      if (messageHistory?.length > 0) {
        if (audio?.muted) {
          playAudioWithRetry();
        }
      } else {
        if (audio) {
          audio.muted = true;
          audio.pause();
          audio.currentTime = 0;
        }
      }
    }
  }, [messageHistory, company, playAudioWithRetry]);

  const updateOrders = (useLoading = true) => {
    if (useLoading) {
      dispatch(loadingOn());
      setLoading(true);
    }

    if (company && company._id !== "" && user?.token !== "") {
      getOrdersByIdCompany(
        {
          idCompany: company._id,
          limit: 100,
          page: 1,
          orderBy: "companyOrderNumber",
          order: "desc",
          searchText: "",
          searchField: "",
          byStatus: "picker-pending",
          byPayment: "none",
          byDate: "none",
          startDate: "none",
          endDate: "none",
          subsidiaryId: subsidiaryId,
        },
        user?.token || ""
      )
        .then((orders) => {
          setMessageHistory(orders.items);
          if (orders?.items?.length === 0) setOpen(false);

          dispatch(loadingOff());
          setLoading(false);
        })
        .catch((err) => {
          dispatch(loadingOff());
          setLoading(false);
          console.log(err);
        });
    }
  };

  useEffect(() => {
    let intervalId;
    let unmounted = false;

    const maybeUpdateOrders = () => {
      if (areSubsidiaryWithinWorkingHours) {
        if (
          !isSubsidiaryAutomaticAceptanceActive ||
          !checkCompanyAutomaticAcceptanceStatus
        ) {
          if (!unmounted) updateOrders(false);
        }
      }
    };

    if (company && company._id !== "") {
      maybeUpdateOrders();
      intervalId = setInterval(() => {
        maybeUpdateOrders();
      }, 120000);
    }
    return () => {
      clearInterval(intervalId);
      unmounted = true;
    };
  }, [
    company,
    subsidiaryId,
    isSubsidiaryAutomaticAceptanceActive,
    areSubsidiaryWithinWorkingHours,
    checkCompanyAutomaticAcceptanceStatus,
  ]);

  const windowTime = (ordertime) => {
    const orderTimeCreated = new Date(ordertime);
    return moment(orderTimeCreated).startOf("minute").fromNow();
  };

  const getReason = (reason) => {
    return {
      "sin-stock": `Lamentablemente ${company.Name} se quedó sin stock para tu pedido 😔`,
      "kitchen-close": `Lamentablemente ${company.Name} ya había cerrado la cocina 🥲 . Disculpa por no avisar en la página dicho inconveniente 😞`,
      "kitchen-busy": `Lamentablemente  la cocina de ${company.Name}  está muy ocupada con muchos pedidos  🥲`,
    }[reason];
  };

  const handleUpdateOrder = (
    orderId,
    userId,
    status,
    time,
    shippingDate = new Date().toISOString(),
    observation = ""
  ) => {
    if (user) {
      dispatch(loadingOn());
      setProcessLoading(true);

      getUserById({ id: userId }, user.token)
        .then((u) => {
          var order = {
            status: status,
            observation: getReason(observation),
            id: orderId,
            idPicker: user.id,
            companyId: company._id,
            rejectReason: getReason(observation),
            logo: company.DesktopLogo,
            companyName: company.Name,
            email: u.email,
            name: `${u.firstName} ${u.lastName}`,
            shippingDate,
          };

          if (time) order.addDeliveryTime = time;
          updateStatus(order, user.token, dispatch)
            .then(async (order) => {
              if (status === orderConstants.ORDER_STATUS.cancel.code) {
              } else {
                var path = `boleta-${orderId}.pdf`;

                if (order.boletaUrl !== "")
                  FileSaver.saveAs(order.boletaUrl, path);
              }
              enqueueSnackbar(
                ReactNotification({
                  text: "Pedido actualizado",
                  variant: "success",
                  withDetails: false,
                })
              );
              updateOrders();
              dispatch(loadingOff());
              setProcessLoading(false);
            })
            .catch((err) => {
              setProcessLoading(false);
              dispatch(loadingOff());
              console.log(err);
              if (typeof err === "string")
                enqueueSnackbar(
                  ReactNotification({
                    text: err,
                    variant: "error",
                    withDetails: false,
                  })
                );
              enqueueSnackbar(
                ReactNotification({
                  text: "Error al actualizar el pedido",
                  variant: "error",
                  withDetails: false,
                })
              );
            });
        })
        .catch((err) => {
          setProcessLoading(false);
          dispatch(loadingOff());
          console.log(err);
          return null;
        })
        .finally(() => queryClient.invalidateQueries({ queryKey: ["orders"] }));
    }
  };

  const SendAccept = (_id, userId, time, date) => {
    handleAccept(_id, userId, time, date, `Aceptado por ${user.email}`);
  };

  const sendRejectReason = (id, orderId, userId) => {
    let rejectReason = document.getElementById(orderId);
    let valuee = rejectReason.value;
    // let valuee = "kitchen-close"

    if (valuee !== "") {
      // console.log("si hay razon puedo enviar");
      handleDecline(id, userId, valuee);
    } else {
      // console.log("debes seleccionar la razón");
      setShowRedMessage(true);
    }
  };

  const handleAccept = (orderId, userId, time, date, observation = "") =>
    handleUpdateOrder(
      orderId,
      userId,
      orderConstants.ORDER_STATUS.inProcess.code,
      time,
      date,
      observation
    );
  const handleDecline = (orderId, userId, observation = "") =>
    handleUpdateOrder(
      orderId,
      userId,
      orderConstants.ORDER_STATUS.cancel.code,
      undefined,
      undefined,
      observation
    );
  return (
    <Fragment>
      <Helmet>
        <link
          rel="icon"
          type="image/png"
          sizes="15x15"
          href="https://s3.amazonaws.com/haya.lumarketo.cl/favicon.ico"
        />
        {/* <title>TIENES PEDIDOS</title> */}
      </Helmet>

      <IconButton
        variant="contained"
        onClick={() => {
          setOpen(true);
        }}
      >
        <StyledBadge
          variant={"standard"}
          color="error"
          badgeContent={messageHistory?.length ?? null}
        >
          <NotificationIcon />
        </StyledBadge>
      </IconButton>

      <Drawer
        anchor={"right"}
        open={open}
        onClose={() => setOpen(false)}
        className={styles.sideBarRoot}
      >
        <TabNotification messageHistory={messageHistory} />
        <Paper
          className={classNames(
            styles.paperSideBar,
            messageHistory.length > 0 ? "" : styles.notFoundPaperPopover
          )}
          style={{
            backgroundColor: "#fff",
          }}
        >
          <Grid container direction="row" justifyContent="right">
            <Grid item xs={12}>
              <IconButton onClick={() => setOpen(false)}>
                <CloseOutlined />
              </IconButton>
            </Grid>
            <Grid
              container
              className={styles.cartListSidebar}
              justifyContent="center"
            >
              {loading ? (
                <div className="row">
                  {" "}
                  <div className="col-12 text-center">
                    <CircularProgress style={{ color: "#000" }} />{" "}
                  </div>{" "}
                </div>
              ) : null}
              {!loading &&
                _orderBy(messageHistory, "companyOrderNumber", "asc").map(
                  (item, index) => (
                    <RenderDetails
                      key={`${item._id}-${index}`}
                      {...{
                        item,
                        company,
                        SendAccept,
                        windowTime,
                        processLoading,
                        sendRejectReason,
                        showRedMessage,
                      }}
                    />
                  )
                )}
            </Grid>
          </Grid>
        </Paper>
      </Drawer>
    </Fragment>
  );
};

const RenderDetails = ({
  item,
  company,
  SendAccept,
  windowTime,
  processLoading,
  sendRejectReason,
  showRedMessage,
}) => {
  const [time, setTime] = useState(shippingConstants.SHIPPING_TIME.Inmediato);
  const [openRefundModal, setOpenRefundModal] = useState(false);
  const loadingUI = useSelector(selectLoadingUI);

  const getPayment = () => {
    if (item.payment === "mercadopago" && item.total !== 0)
      return (
        <img
          src="https://s3.amazonaws.com/lumarketo.cl/mercadopago-svg-payments.svg"
          alt="mercadopago"
          width="85px"
        />
      );
    else if (item.payment === "getnet" && item.total !== 0) {
      return (
        <img
          src="https://luma-photos.s3.us-east-1.amazonaws.com/getnet_logo.svg"
          alt="getnet"
          width={85}
        />
      );
    } else if (item.payment === "fintoc" && item.total !== 0) {
      return (
        <img
          src="https://dgdvd9d8e5bk8.cloudfront.net/fintoc.svg"
          alt="fintoc"
          width={85}
        />
      );
    } else if (item.payment === "edenred" && item.total !== 0) {
      return (
        <img
          src="https://dgdvd9d8e5bk8.cloudfront.net/edenred.svg"
          alt="edenred"
          width={85}
        />
      );
    } else if (item.payment === "amipass" && item.total !== 0) {
      return (
        <img
          src="https://dgdvd9d8e5bk8.cloudfront.net/amipass.svg"
          alt="amipass"
          width={85}
        />
      );
    } else if (item.total === 0) {
      return <strong>Sin método de pago debido a cupones y descuentos</strong>;
    } else
      return (
        <strong>
          {paymentConstants.TYPES_NAMES[item.payment] || "No definido"}
        </strong>
      );
  };

  return (
    <div className={styles.detailsContainer} key={item._id}>
      <p className={styles.orderTimeDate}>{windowTime(item.createdDate)}</p>

      <div className={styles.orderCartGeneralContainerBox}>
        <div className={styles.orderCartContainer}>
          <div className={styles.orderCartIconSideBar}>
            <img
              className={styles.iconSideCartOrder}
              width="100%"
              src={
                item.products[0].skuInfo.Imgs.length > 0 &&
                  item.products[0].skuInfo.Imgs[0].Path &&
                  item.products[0].skuInfo.Imgs[0].Path !== ""
                  ? item.products[0].skuInfo.Imgs[0].Path
                  : noImage
              }
              alt=""
            />
          </div>
          <div>
            <p className={styles.orderCartText}>
              {" "}
              Haz recibido un pedido{" "}
              <strong> #({item.companyOrderNumber})</strong> de{" "}
              <strong>{item.customerName} </strong>
              de un total de{" "}
              <strong>
                {" "}
                ${lumaUtils.numberUtils.formatNumber(item.total)}
              </strong>{" "}
              con {item.products.length} producto(s)
            </p>
          </div>
        </div>

        {/* Pedido nro: {item.companyOrderNumber} */}
      </div>
      <div className={styles.ItemsDetailsContainer}>
        <p className={styles.detailsTitleText}>DETALLES DEL PEDIDO</p>
        {item.products.map((product, index) => {
          return (
            <div key={`${product._id}-${index}`}>
              <div className={styles.itemDetailContainerSideCart}>
                <div>
                  <p className={styles.itemDetailNameSideCart}>
                    {" "}
                    {product.quantity}
                  </p>
                </div>

                <div>
                  <p className={styles.itemDetailNameSideCart}>
                    {" "}
                    {product.productInfo.Name}
                    {product.skuInfo.Size !== ""
                      ? ` - ${product.skuInfo.Size}`
                      : ""}
                  </p>
                </div>
              </div>

              {product.additionals.length > 0 && (
                <p className={styles.itemDetailNameSideCart}>Con:</p>
              )}

              {product.additionals.length > 0 &&
                product.additionals.map((aditional, index) => {
                  return (
                    <p
                      key={uuid()}
                      className={styles.itemDetailNameSideCartExtra}
                    >
                      {aditional.description}
                    </p>
                  );
                })}

              {product.instructions !== "" && (
                <div>
                  <p>
                    {" "}
                    Instrucciones especiales:{" "}
                    <span className={styles.itemDetailNameSideCart}>
                      {product.instructions}
                    </span>
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className={styles.orderInformation}>
        {item.address && item.address.address && (
          <p>
            Dirección:{" "}
            <span className={styles.itemDetailNameSideCart}>
              {`${item.address.address}, ${item.address.streetNumber}, ${item.address.details}`}
            </span>
          </p>
        )}
        <p>Método de pago: {getPayment()}</p>
        <p>
          Método de Envío:{" "}
          {item.shippingPolicy &&
            item.shippingPolicy.fulfillmentId === "Pedidosya" && (
              <img
                src="https://www.ccs.cl/wp-content/uploads/2022/10/PedidosYa-Envi%CC%81os_rojo-vertical.png"
                alt="pedidosYa"
                width="85px"
              />
            )}
          {item.shippingPolicy &&
            item.shippingPolicy.fulfillmentId === "Cabify" && (
              <img
                src="https://s3.amazonaws.com/haya.lumarketo.cl/Cabify-Logo-Moradul-RGB.png"
                alt="cabify"
                width="85px"
              />
            )}
          {item.shippingPolicy &&
            item.shippingPolicy.fulfillmentId === "Uber" && (
              <img
                src="https://dgdvd9d8e5bk8.cloudfront.net/uberdireclogowebp.webp"
                alt="uber"
                width="85px"
              />
            )}
          {item.shippingPolicy &&
            item.shippingPolicy.fulfillmentId !== "Cabify" &&
            item.shippingPolicy.fulfillmentId !== "Pedidosya" &&
            item.shippingPolicy.fulfillmentId !== "Uber" && (
              <span className={styles.itemDetailNameSideCart}>
                {" "}
                Envío propio
              </span>
            )}
          {!item.shippingPolicy && item.subsidiary && (
            <span className={styles.itemDetailNameSideCart}>
              {" "}
              Retiro en restaurant
            </span>
          )}
        </p>
        {item?.fiscalDocument &&
          item?.fiscalDocument?.documentType &&
          item?.fiscalDocument?.documentNumber && (
            <p className={styles.fiscalDocumentLabel}>
              **Pedido con {item?.fiscalDocument?.fiscalDocumentType}**
            </p>
          )}
      </div>
      <div className={styles.containersAcceptRejectOrder}>
        <p className={styles.buttonsContainerRejectOrderSideCart}>
          <div
            className={styles.containerRejectOrderSideCartSubContainerButtons}
          >
            {company.PrintOrder ? (
              <PDFOrder
                fiscalDocument={item?.fiscalDocument}
                useFee={item.subsidiary.useFee}
                fee={item.fee}
                createdDate={lumaUtils.dateUtils.momentLib
                  .tz(item.createdDate, "America/Santiago")
                  .format()}
                model={company.TicketType}
                title={lumaUtils.stringUtils.slugifyText(
                  company.Name,
                  " ",
                  false
                )}
                address={
                  item.subsidiary &&
                  item.subsidiary.AddressInfo &&
                  lumaUtils.stringUtils.slugifyText(
                    item.subsidiary.AddressInfo.address,
                    " ",
                    false
                  )
                }
                tlf={(item.subsidiary && item.subsidiary.Tlf) || ""}
                orderNumber={item.companyOrderNumber}
                products={item.products}
                total={item.total}
                userAddress={
                  item.address
                    ? lumaUtils.stringUtils.slugifyText(
                      `${item.address.address}, ${item.address.streetNumber}, ${item.address.details}`,
                      " ",
                      false
                    )
                    : item.subsidiary && !item.shippingPolicy
                      ? "Sin direccion"
                      : "Sin direccion"
                }
                fullName={
                  item.user
                    ? lumaUtils.stringUtils.slugifyText(
                      `${item.user.firstName} ${item.user.lastName}`,
                      " ",
                      false
                    )
                    : "No disponible"
                }
                userTlf={item.user ? item.user.tlf : "No definido"}
                linkStyle="editLabel"
                disabled={processLoading || loadingUI}
                linkText="Hacer click para descargar"
                companyLogo={company.DesktopLogo}
                shippingCost={item.shippingCost}
                shipping={
                  item.shippingPolicy && item.shippingPolicy.name
                    ? lumaUtils.stringUtils.slugifyText(
                      item.shippingPolicy.name,
                      " ",
                      false
                    )
                    : item.shippingPolicy && item.shippingPolicy.fulfillmentId
                      ? lumaUtils.stringUtils.slugifyText(
                        item.shippingPolicy.fulfillmentId,
                        " ",
                        false
                      )
                      : item.subsidiary
                        ? "Retiro en sucursal"
                        : "No definido"
                }
                distance={(item.subsidiary && item.subsidiary.Distance) || 0}
                buttonStyle={styles.acceptOrderButtom}
                onClick={() => {
                  SendAccept(item._id, item.idUser, time, item.shippingDate);
                }}
                buttonText={
                  processLoading ? (
                    <div className="col-12 text-center">
                      <CircularProgress
                        style={{
                          color: "#fff",
                          height: 15,
                          width: 15,
                        }}
                      />{" "}
                    </div>
                  ) : (
                    "Aceptar"
                  )
                }
              />
            ) : (
              <button
                onClick={() => {
                  SendAccept(item._id, item.idUser, time, item.shippingDate);
                }}
                className={styles.acceptOrderButtom}
                disabled={processLoading || loadingUI}
              >
                {processLoading || loadingUI ? (
                  <div className="col-12 text-center">
                    <CircularProgress
                      style={{
                        color: "#fff",
                        height: 15,
                        width: 15,
                      }}
                    />{" "}
                  </div>
                ) : (
                  "Aceptar"
                )}
              </button>
            )}
          </div>
          {item.shippingPolicy &&
            item.shippingPolicy.fulfillmentId !== "" &&
            !item?.useScheduling && (
              <div
                className={
                  styles.containerRejectOrderSideCartSubContainerLabelsInputs
                }
              >
                <p className={styles.labelRejectAceptOrder}>
                  ¿Cuando quieres buscar el delivery?
                </p>
                <select
                  value={time}
                  onChange={(e) => {
                    setTime(e.target.value);
                  }}
                  className={styles.rejectReasonSelect}
                >
                  <option value="" disabled selected>
                    Selecciona el tiempo de espera para el envío
                  </option>
                  <option value={shippingConstants.SHIPPING_TIME.Inmediato}>
                    Inmediato
                  </option>
                  <option value={shippingConstants.SHIPPING_TIME["10min"]}>
                    10min
                  </option>
                  <option value={shippingConstants.SHIPPING_TIME["15min"]}>
                    15min
                  </option>
                  <option value={shippingConstants.SHIPPING_TIME["20min"]}>
                    20min
                  </option>
                  <option value={shippingConstants.SHIPPING_TIME["25min"]}>
                    25min
                  </option>
                  <option value={shippingConstants.SHIPPING_TIME["30min"]}>
                    30min
                  </option>
                  <option value={shippingConstants.SHIPPING_TIME["45min"]}>
                    45min
                  </option>
                  <option value={shippingConstants.SHIPPING_TIME["60min"]}>
                    60min
                  </option>
                </select>
              </div>
            )}

          {item?.useScheduling && item?.shippingDate && (
            <div
              className={
                styles.containerRejectOrderSideCartSubContainerLabelsInputs
              }
            >
              <p className={styles.labelRejectAceptOrder}>
                Pedido programado para :{" "}
                <span className={styles.itemDetailNameSideCart}>
                  {lumaUtils.dateUtils
                    .momentLib(item?.shippingDateLambda ?? undefined)
                    .tz("America/Santiago")
                    .format("DD/MM/YYYY HH:mm")}
                </span>
              </p>
            </div>
          )}
        </p>
        <p className={styles.buttonsContainerRejectOrderSideCart}>
          <div
            className={styles.containerRejectOrderSideCartSubContainerButtons}
          >
            <button
              onClick={
                () => setOpenRefundModal(true)
                // sendRejectReason(item._id, item.companyOrderNumber, item.idUser)
              }
              className={styles.rejectOrderButtom}
              disabled={processLoading}
            >
              {processLoading ? (
                <div className="col-12 text-center">
                  <CircularProgress
                    style={{
                      color: "#fff",
                      height: 15,
                      width: 15,
                    }}
                  />
                </div>
              ) : (
                "Rechazar"
              )}
            </button>
            {/* <select id={item.companyOrderNumber} onChange={(e) => { handleRejectReason(e) }} className={styles.rejectReasonSelect}>
                            <option value="" disabled selected>Selecciona la razón</option>
                            <option value="sin-stock">Sin stock</option>
                            <option value="kitchen-close">Cocina cerrada</option>
                            <option value="kitchen-busy">Cocina muy ocupada</option>
                        </select> */}
          </div>
          <div
            className={
              styles.containerRejectOrderSideCartSubContainerLabelsInputs
            }
          >
            <p className={styles.labelRejectAceptOrder}>
              Indica la razón del rechazo
            </p>
            <SelectReason id={item.companyOrderNumber} />
          </div>
        </p>
        {showRedMessage && (
          <p style={{ color: "red" }}>
            Debes seleccionar la razón del rechazo para notificarle al cliente.
          </p>
        )}
      </div>
      <RefundModal
        loading={processLoading}
        open={openRefundModal}
        handleClose={() => setOpenRefundModal(false)}
        orderNumber={item.companyOrderNumber}
        handleAccept={() =>
          sendRejectReason(item._id, item.companyOrderNumber, item.idUser)
        }
        fullName={item.user ? item.user.firstName : "No definido"}
        operationId={
          item.getnetRequestId !== ""
            ? item.getnetRequestId
            : item.mercadopagoPaymentId
        }
        paymentMethod={item.payment}
      />
    </div>
  );
};

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -1,
    top: -2,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
    fontSize: 9,
  },
}))((props) => <Badge overlap="rectangular" {...props} />);
